export const WHATSAPP_NUMBER = '917736860045';

export const BUSINESS_INFO = {
  name: 'LOJE',
  email: 'lojedress@gmail.com',
  phone: '+91 77368 60045',
  address: 'Kerala, India',
  website: 'https://loje.in'
};

export const SOCIAL_LINKS = {
  whatsapp: `https://wa.me/${WHATSAPP_NUMBER}`,
  instagram: 'https://instagram.com/loje',
  facebook: 'https://facebook.com/loje'
};
